import { apiNames, get, fetchQuery } from '@general/api/shared';

export const url = 'functional-titles';
const fetchRequest = () => get(apiNames.MEMBERSHIP, url);

export const getFunctionalTitles = ({ transformData }) => fetchQuery({ fetchRequest, transformData });
